import { render, staticRenderFns } from "./MesMaterialList.vue?vue&type=template&id=6b6f57fa&scoped=true&"
import script from "./MesMaterialList.vue?vue&type=script&lang=js&"
export * from "./MesMaterialList.vue?vue&type=script&lang=js&"
import style0 from "./MesMaterialList.vue?vue&type=style&index=0&id=6b6f57fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6f57fa",
  null
  
)

export default component.exports